// extracted by mini-css-extract-plugin
module.exports = {"title_render_container":"title_render_container___r5K1p","logo_new":"logo_new___4KASW"};